import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getClientDetail} from './getClientDetail';

export const clientDetailQueryOptions = (id: string) =>
  queryOptions({
    queryKey: keys.clients.detail(id),
    queryFn: () => getClientDetail(id),
    staleTime: 30_000,
  });
